import WorkIcon from "@material-ui/icons/Work";
import ProfessionList from "./ProfessionList";

export default {
  list: ProfessionList,
  icon: WorkIcon,
};
